import React, { useEffect, useMemo, useRef, useState } from "react";
import "../../css/CustomSelect.css";
import {ReactComponent as ArrowDownIcon} from "../../assets/icons/ArrowDown.svg";

const CustomSelect = ({
  options = [],
  value = "",
  onChange,
  placeholder = "Select...",
  disabled = false,
  error = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  const selectedOption = useMemo(
    () => options.find((opt) => opt.id === value),
    [options, value],
  );

  const handleSelect = (opt) => {
    if (disabled) return;

    onChange?.({ target: { value: opt.id } });
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      className={`custom-select ${disabled ? "is-disabled" : ""} ${
        error ? "has-error" : ""
      }`}
      ref={wrapperRef}
    >
      <button
        type="button"
        className="custom-select__trigger help-text"
        onClick={() => !disabled && setIsOpen((prev) => !prev)}
      >
        <span
          className={`${selectedOption ? "selected-text" : "placeholder-text"} help-text`}
        >
          {selectedOption ? selectedOption.label : placeholder}
        </span>
        <span className={`custom-select__arrow ${isOpen ? "open" : ""}`}>
          <ArrowDownIcon />
        </span>
      </button>

      {isOpen && (
        <div className="custom-select__menu">
          {options.map((opt) => (
            <button
              type="button"
              key={opt.id || opt.label}
              className={`custom-select__option help-text ${
                value === opt.id ? "is-selected" : ""
              } help-text`}
              onClick={() => handleSelect(opt)}
            >
              {opt.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomSelect;
